export const VALIDATE_FINALIZE_STATE_ERROR_CODE = "10";
export const FINALIZE_SORTBOX_ERROR_CODE = "20";
export const POLL_FOR_IS_PACKING_ALLOWED_ERROR_CODE = "30";
export const PERFORM_NEXT_ACTION_SET_CART_ERROR_CODE = "40";
export const PERFORM_NEXT_ACTION_SEARCH_BOX_ERROR_CODE = "50";
export const PERFORM_NEXT_ACTION_DEFAULT_ERROR_CODE = "60";
export const SHOW_MESSAGE_NO_INSTRUCTION_ERROR_CODE = "80";
export const SHOW_WORKSTATION_INSTRUCTION_ERROR_CODE = "90";
export const SHOW_WORKSTATION_NO_INSTRUCTION_ERROR_CODE = "100";
export const GET_SKU_ID_FROM_INPUT_ERROR_CODE = "110";
export const SCAN_INPUT_TYPE_2D_ERROR_CODE = "120";
export const SEND_EVERIFICATION_SCAN_ERROR_CODE = "130";
export const ON_ERROR_FINALIZE_SORTBOX_ERROR_CODE = "140";
export const CANCEL_SORTBOX_ERROR_CODE = "150";
export const FAILURE_TO_DELIVER_CANCEL_SORTBOX_ERROR_CODE = "160";
export const OPERATOR_CONFIRM_MODAL_ERROR_CODE = "170";
export const FINISH_NOT_FOUND_NO_PERMISSION_ERROR_CODE = "180";
export const FINISH_NOT_FOUND_PACKING_NOT_ALLOWED_ERROR_CODE = "190";
export const FINISH_NOT_FOUND_RX_SINGLE_BLOCKED_ERROR_CODE = "200";
export const FINISH_NOT_FOUND_RX_SINGEL_NOT_FOUND_ERROR_CODE = "210";
export const FINISH_NOT_FOUND_FINALIZE_SORT_MODAL_OPEN_ERROR_CODE = "220";
export const FINISH_NOT_FOUND_HAS_INPUT_WAS_AFFECTED_BY_OFFSET_ERROR_CODE = "230";
export const FINISH_NOT_FOUND_WAS_AFFECTED_BY_OFFSET_ERROR_CODE = "240";
export const FINISH_NOT_FOUND_ARTICLE_DOES_NOT_BELONG_TO_PICKLIST_ERROR_CODE = "250";
export const UNAUTHORIZED_COMPANY_ERROR_CODE = "260";
export const REPARK_CART_INSTRUCTION = "270";
export const FINISH_NOT_FOUND_STATION_NOT_ALLOWED_ERROR_CODE = "280";
export const FINISH_NOT_FOUND_MULTIPLE_SORTS_CART = "290";